import { z } from 'zod';

export const ExamCategoryEnum = z.enum(['LAB', 'IMAGE', 'VACCINE']);
export const ExamTrimesterEnum = z.enum(['1', '2', '3']);

export const ExamSchema = z.object({
    id: z.string(),
    // Opcional como em `consultation.schema.ts`: uma tentante ou quem perdeu o bebê
    // pode ter exame sem haver gestação. Era obrigatório aqui e opcional lá,
    // assimetria sem motivo.
    pregnancyId: z.string().optional(),
    /**
     * Marca da sessão em que o registro aconteceu (A052, fase 2). Opcional
     * enquanto o dado antigo é backfillado; a leitura passa a filtrar por ele
     * na fase 3. Cada CRM vê só o que aconteceu na própria marca.
     */
    brandId: z.string().nullable().optional(),

    date: z.date(),
    trimester: ExamTrimesterEnum,
    category: ExamCategoryEnum,
    name: z.string().min(1),

    // Resultado pode ser numérico ou texto
    resultValue: z.string().optional(),

    // URL para arquivo anexado (PDF/Imagem)
    attachmentUrl: z.string().url().optional(),

    createdAt: z.date(),
    updatedAt: z.date(),
});

export type Exam = z.infer<typeof ExamSchema>;
export type ExamCategory = z.infer<typeof ExamCategoryEnum>;
export type ExamTrimester = z.infer<typeof ExamTrimesterEnum>;
